import { CUSTOMERS_ACTIONS } from "./Customers.actions";
import INFRAMARK_CONSTANTS from "common/Constants/inframark-constants";

export const CustomersReducer = (state, action) => {
  switch (action.type) {
    case CUSTOMERS_ACTIONS.LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case CUSTOMERS_ACTIONS.ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case CUSTOMERS_ACTIONS.CUSTOMERSLIST:
      return {
        ...state,
        customersList: action.payload.list ?? [],
        customers: action.payload.list ?? [],
        pagination: action.payload.pagination ?? state.pagination,
        error: null,
      };
    case CUSTOMERS_ACTIONS.LIST_FILTERS:
      return {
        ...state,
        listFilters: action.payload ?? state.listFilters,
      };
    case CUSTOMERS_ACTIONS.SELECTEDVIEW:
      return {
        ...state,
        selectedView: action.payload.status,
        selectedCustomer: action.payload.customer,
      };
    case CUSTOMERS_ACTIONS.EDITUSER:
      return {
        ...state,
        selectedView: INFRAMARK_CONSTANTS.groups.constants.GROUPEDITEVIEW,
        selectedCustomer: action.payload,
      };
    case CUSTOMERS_ACTIONS.SELECTEDCUSTOMER:
      return {
        ...state,
        selectedCustomer: action.payload,
      };
    case CUSTOMERS_ACTIONS.SEARCHCUSTOMER: {
      const searchString = action.payload.toLowerCase();
      const filteredCustomers = state.customers.filter((customer) => {
        return (
          customer.name.toLowerCase().includes(searchString) ||
          (customer.code ?? "").toString().toLowerCase().includes(searchString)
        );
      });
      return {
        ...state,
        customersList: filteredCustomers.length > 0 ? filteredCustomers : [],
      };
    }
    default:
      return { ...state };
  }
};
